import { PulseLoader } from 'react-spinners'
import logo from '../assets/GB.png'

const SplashScreen = ({ fading }) => {
  return (
    <div className={`splash-screen bg-white position-fixed top-0 start-0 w-100 h-100 d-flex flex-column align-items-center justify-content-center${fading ? ' fading' : ''}`} style={{ zIndex: 10000 }}>
      <div className={`splash-content d-flex flex-column align-items-center${fading ? ' splash-content--exiting' : ''}`}>
        <img src={logo} alt="Gymnastic Britannia" className="splash-logo img-fluid" style={{ width: '12rem' }} />
        <div className="mt-4">
          <PulseLoader color="var(--bs-info)" size={10} />
        </div>
      </div>
    </div>
  )
}

export default SplashScreen
